import {appFetch, AppFetchResponse} from "../utils/appFetch";

const getDashboardCampaignBoxes = (days: number, selectedDomain: string, customDates?: { from: Date, to: Date }): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `statistics/campaigns/dashboard-boxes/${days}?domain=${selectedDomain}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}

export default getDashboardCampaignBoxes;